import { captureError } from '@src/utils/errors'
import * as React from 'react'

interface Props {
  errorView: React.ReactNode
  children: React.ReactNode
}

interface State {
  hasError: boolean
}
export default class BaseErrroBoundary extends React.Component<Props, State> {
  public static getDerivedStateFromError() {
    return { hasError: true }
  }
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  public componentDidCatch(error: Error) {
    captureError(error)
    console.error(error)
  }

  public render() {
    if (this.state.hasError) {
      return this.props.errorView
    }

    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/BaseErrorBoundary.tsx